import React from 'react';
import classNames  from 'classnames';
const VehicleHistoryList = ({VehicleHistoryList}) => {

    
const getCompactDateTime = (vehicle) => {
    const locale = (navigator && navigator.language) || "en"
    const date = vehicle.dateTimeUtc ? new Date(vehicle.dateTimeUtc).toLocaleString(locale, {
        day: "numeric",
        month: "short",
        year: "numeric"
    }) : null
    const time = vehicle.dateTimeUtc ? new Date(vehicle.dateTimeUtc).toLocaleString(locale, {
        timeStyle: "short"
    }) : null
    return date && time ? `${date} - ${time}` : null
}

const vehicleList = VehicleHistoryList.map((vehicle, index) => { 
    const listGroupItemClasses = classNames({
        'list-group-item': true,
        'list-group-item-danger': vehicle.isDriveOff
    });
    
    return (
        <li key={`${vehicle.plate}-${index}`} className={listGroupItemClasses}>
            <div className="py-2">
                <div className="small">{getCompactDateTime(vehicle)}</div>
                {vehicle.notes && <div className="fw-bold mt-1">{vehicle.notes}</div>}
            </div>
        </li>
    )
   }
)




   return (
        <React.Fragment>
            {vehicleList.length? vehicleList: <li className='list-group-item'>No reported history.</li>}
        </React.Fragment>
    
    );
}

export default VehicleHistoryList;
 